export class QueryParamsModel {

  processId?: string;
  sessionId?: string;
  offerId?: string;

  constructor() { }
}
